import {
  Container,
  FormControl,
  IconButton,
  Input,
  InputAdornment,
  InputLabel,
  TextField,
} from "@mui/material";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./login.css";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Box } from "@mui/system";
import toast from "react-hot-toast";
import Loader from "../../components/loader/Loader";
import { api } from "../../api/api";

function Register() {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [type, setType] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const submitRegister = async () => {
    if (!username?.trim()) {
      toast.error("Username is required");
      return;
    }
    if (!email?.trim()) {
      toast.error("Email is required");
      return;
    }
    if (!password) {
      toast.error("Password is required");
      return;
    }
    setIsSubmitting(true);
    try {
      const res = await api.post("/user/register-public", {
        username: username.trim(),
        email: email.trim(),
        password,
      });
      if (res.status === 201 && res.data?.isRegistered) {
        toast.success("Registration successful. Please login.");
        navigate("/login");
      } else {
        toast.error(res.data?.message || "Registration failed");
      }
    } catch (err) {
      const msg =
        err.response?.data?.message ||
        (err.code === "ERR_NETWORK" ? "Cannot reach server." : err.message);
      toast.error(msg);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Box
        sx={{
          minHeight: "100vh",
          maxWidth: "100vw",
          display: "flex",
          position: "relative",
          margin: 0,
          padding: 0,
          boxSizing: "border-box",
          backgroundColor: "#faf3e0",
        }}
      >
        {isSubmitting && (
          <>
            <Box
              sx={{
                height: "100vh",
                width: "100vw",
                position: "absolute",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                background: "rgba(0,0,0,0.5)",
                top: 0,
                left: 0,
                bottom: 0,
                right: 0,
                zIndex: "100000",
              }}
            >
              <Loader />
            </Box>
          </>
        )}

        <Box
          sx={{
            height: "100dvh",
            width: "70dvw",
            backgroundImage: `url(/images/notiz-logo.png)`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            backgroundSize: "contain",
            display: { lg: "block", md: "block", sm: "none", xs: "none" },
          }}
        ></Box>
        <Box
          sx={{
            height: "100dvh",
            width: {
              xl: "30dvw",
              lg: "30dvw",
              md: "30dvw",
              sm: "100dvw",
              xs: "100dvw",
            },
          }}
        >
          <Container maxWidth="xl">
            <Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100vh",
                  position: "relative",
                }}
              >
                <Box
                  sx={{
                    width: { lg: "100%", md: "100%", sm: "99%", xs: "99%" },
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div className="login-form">
                    <div className="login-form-header">
                      <div className="logo-sec">
                        <Box
                          sx={{
                            height: { xl: "120px", lg: "120px", md: "120px", sm: "70px", xs: "70px" },
                            width: { xl: "120px", lg: "120px", md: "120px", sm: "70px", xs: "70px" },
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <img
                            src="/images/notiz-logo.png"
                            style={{ height: "100%", width: "100%", objectFit: "contain" }}
                            alt="NOTIZ Logo"
                          />
                        </Box>
                      </div>
                    </div>
                    <div className="login-form-body">
                      <div className="title">
                        <Box
                          sx={{
                            height: "15%",
                            width: "100%",
                            display: "flex",
                            margin: "20px 0",
                            fontFamily: "'Montserrat', sans-serif",
                            fontWeight: 700,
                            color: "#313031",
                            marginTop: "-7px",
                            marginLeft: "10px",
                            fontSize: { xl: "40px", lg: "40px", md: "40px", sm: "25px", xs: "25px" },
                          }}
                        >
                          Register
                        </Box>
                      </div>
                      <div className="input-fields">
                        <TextField
                          value={username}
                          onChange={(e) => setUsername(e.target.value)}
                          variant="standard"
                          label="Username"
                          fullWidth
                          style={{ borderBottom: "1px solid #008080", color: "#008080" }}
                        />
                      </div>
                      <div className="input-fields">
                        <TextField
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          type="email"
                          variant="standard"
                          label="Email"
                          fullWidth
                          style={{ borderBottom: "1px solid #008080", color: "#008080" }}
                        />
                      </div>
                      <div className="input-fields">
                        <FormControl variant="standard" fullWidth>
                          <InputLabel htmlFor="reg-password">Password</InputLabel>
                          <Input
                            id="reg-password"
                            type={type ? "password" : "text"}
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            endAdornment={
                              <InputAdornment position="end" style={{ marginTop: "-10px", color: "#008080" }}>
                                <IconButton
                                  aria-label="toggle password visibility"
                                  onClick={() => setType(!type)}
                                >
                                  {type ? (
                                    <VisibilityOffIcon style={{ color: "#008080" }} />
                                  ) : (
                                    <VisibilityIcon style={{ color: "#008080" }} />
                                  )}
                                </IconButton>
                              </InputAdornment>
                            }
                          />
                        </FormControl>
                      </div>
                      <div className="button-field" style={{ marginTop: 16 }}>
                        <button
                          className="btn-login"
                          onClick={submitRegister}
                          disabled={isSubmitting}
                        >
                          Register
                        </button>
                      </div>
                      <div style={{ textAlign: "center", marginTop: 12 }}>
                        <Link to="/login">Already have an account? Login</Link>
                      </div>
                    </div>
                  </div>
                </Box>
              </Box>
            </Box>
          </Container>
        </Box>
      </Box>
    </>
  );
}

export default Register;
